<app-master-data-table [data]="masterCommonService.paymentsList" [columns]="paymenttypeColumns"
  title="Payment Types List" addButtonLabel="Payment Type" (add)="openAddUpdatePaymentTypeDialog('add')"
  (update)="openAddUpdatePaymentTypeDialog('update', $event)" (delete)="deletePaymentType($event)">
</app-master-data-table>